export default __webpack_public_path__ + "static/media/1.3460c9b7.jpeg";